import React from 'react'
import { Link } from 'react-router-dom'
import { AppBar, Button, IconButton, Toolbar } from '@material-ui/core'
//import { ReactComponent as MenuIcon } from '../assets/menu.svg'
//import { ReactComponent as CloseMenu } from '../assets/close.svg'

// Navigaatiopalkki
const NaviMenu = () => {
  return (
    <AppBar position="static" style={{ background: 'black', opacity: 0.7 }}>
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu">
        </IconButton>
        <Button color="inherit" component={Link} to="/Pilot-sites">
          Pilot Sites
        </Button>
        <Button color="inherit" component={Link} to="/Calculators">
          Calculators
        </Button>
        <Button color="inherit" component={Link} to="/">
          About Project
        </Button>
      </Toolbar>
    </AppBar>
  )
  /*
  const [ click, setClick ] = useState(false)

  const handleClick = () => setClick(!click)
  const closeMenu = () => setClick(false)


  return (
    <div className="navimenu">

      <ul className={click ? 'nav-opt active' : 'nav-opt'}>
        <li className="btn" onClick={closeMenu}><Link className="btn-a" to="/">Home</Link></li>
        <li className="btn" onClick={closeMenu}><Link className="btn-a" to="/Ulkolampotila">Outdoor Sensor</Link></li>
        <li className="btn" onClick={closeMenu}><Link className="btn-a" to="/Sisailma-1">Indoor Sensor 1</Link></li>
      </ul>
      <ul className="menu-button">
        <div className="mobile-menu" onClick={handleClick}>
          {click ? (
            <CloseMenu className="menu-icon" />
          ) : (
            <MenuIcon className="menu-icon" />
          )}
        </div>
      </ul>
    </div>

    )
 */

}

export default NaviMenu